import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LoanService } from '../../services/loan/loan.service';
import { ToastService } from '../../services/general/toast.service';
import { ConfirmationDialogComponent } from '../../components/shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-webhook-trigger',
  imports: [CommonModule, ReactiveFormsModule, ConfirmationDialogComponent],
  templateUrl: './webhook-trigger.component.html',
})
export class WebhookTriggerComponent {
  private _fb = inject(FormBuilder);
  private loanService = inject(LoanService);
  private _toast = inject(ToastService);

  isLoading = false;
  showConfirmDialog = false;

  webhookEvents = [
    { label: 'Loan Disbursed', value: 'loan.disbursed' },
    { label: 'Loan Rejected', value: 'loan.rejected' },
    { label: 'Loan Approved', value: 'loan.approved' },
    { label: 'Loan Cancelled', value: 'loan.cancelled' },
    { label: 'Loan Processing', value: 'loan.processing' },
    { label: 'Loan Counter', value: 'loan.counter' },
    { label: 'Loan Repayment', value: 'loan.repayment' },
  ];

  form: FormGroup = this._fb.group({
    url: [''],
    loanId: ['', Validators.required],
    event: ['loan.disbursed', Validators.required],
  });

  get payloadPreview(): string {
    const { url, loanId, event } = this.form.value;
    const obj: Record<string, string> = {};
    if (url?.trim()) obj['url'] = url.trim();
    obj['loanId'] = loanId || 'string';
    obj['event'] = event;
    return JSON.stringify(obj, null, 2);
  }

  get selectedEventLabel(): string {
    return this.webhookEvents.find(e => e.value === this.form.value.event)?.label || this.form.value.event;
  }

  trigger(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.showConfirmDialog = true;
  }

  cancelTrigger(): void {
    this.showConfirmDialog = false;
  }

  confirmTrigger(): void {
    this.showConfirmDialog = false;
    const { url, loanId, event } = this.form.value;
    this.isLoading = true;
    this.loanService.triggerWebhook(loanId.trim(), event, url?.trim() || undefined).subscribe({
      next: () => {
        this._toast.success('Webhook triggered successfully');
        this.isLoading = false;
      },
      error: (err) => {
        const message = err?.error?.message || err?.message || 'Failed to trigger webhook';
        this._toast.error(message);
        this.isLoading = false;
      }
    });
  }

}
